import React from 'react';
import {backArrow, logoName, close} from '../../../utils/images';
import {View, Text, TouchableOpacity} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FastImage from '../../../common/FastImage';
import {globalImport} from '../../../common/globalImports';
import {isMobile} from '../../../utils/commonMethods';
import {useSelector} from 'react-redux';
import Width from '../../../assets/Width';
import {
  globalConfigurableData,
  globalConst,
} from '../../../utils/globalConstant';

const LoginHeader = ({
  onCloseBtnClick,
  mode,
  mobileNo,
  isIndia,
  emailLogin,
  method,
  isModal,
}) => {
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const isShowOptionType = emailLogin || method === 'mobile';

  return (
    <View style={{backgroundColor: Colors.bgWhite}}>
      <View
        style={{
          paddingTop: isModal ? 0 : 20,
          backgroundColor: Colors.bgWhite,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        {!isModal ? (
          <TouchableOpacity onPress={onCloseBtnClick}>
            <View style={{marginBottom: 20, width: '100%'}}>
              <FastImage source={backArrow()} style={{width: 15, height: 15}} />
            </View>
          </TouchableOpacity>
        ) : (
          <View />
        )}
        
        {isModal && (
          <TouchableOpacity onPress={onCloseBtnClick}>
            <FastImage 
              source={close()} 
              style={{width: 24, height: 24}} 
            />
          </TouchableOpacity>
        )}
      </View>

      {mode !== 'otpless' && (isIndia || isShowOptionType) && (
        <View style={{paddingHorizontal: 16, paddingTop: 30}}>
          <Text
            style={{
              ...globalFontStyle.appFontTitle,
              color: Colors.black,
              paddingBottom: 5,
            }}>
            {mode === 'login' ? 'Login or Create a New Account' : 'Verify OTP'}
          </Text>
          {mode !== 'login' && (
            <Text
              style={{
                ...globalFontStyle.appFontBody,
                color: Colors.lightgrey,
                paddingBottom: 5,
              }}>
              {`Please enter the 6-digit otp sent to ${mobileNo}`}
            </Text>
          )}
        </View>
      )}
    </View>
  );
};

export default LoginHeader;
